import { capitalize, paymentTypeMap } from '@core/utils';
import type { ItemCategory } from '@src/types'
import type { OrderFormItem, OrderForm, LogisticsInfo } from "./types";

export const getOrderFormItems = (orderForm: OrderForm): OrderFormItem[] => {
  const idSelected = orderForm?.selected;
  const isMultipleRemove = orderForm?.multipleRemove;

  return idSelected
    ? orderForm.items.filter((item: OrderFormItem) => item.id === idSelected).map((i) => {
      if (isMultipleRemove) return i;
      return { ...i, quantity: 1 }
    })
    : orderForm.items;
};

export const getItemCategory = (item: OrderFormItem): ItemCategory => {
  const categories = item?.productCategories;
  if (!categories) return "Coleção";

  // Junta todos os valores das categorias em uma string
  const text = Object.values(categories).join(" ");
  const match = text.match(/outlet|bazar|sale/i)?.[0].toLowerCase();

  return (match as ItemCategory) ?? "Coleção";
};

export const getItemCategory2 = (item: OrderFormItem): string => {
  const AVOID_CATEGORIES = /outlet|bazar|sale/i;
  const categories = Object.values(item?.productCategories ?? {});
  const validHierarchy = categories
    .map(c => c.trim())
    .filter(c => c && !AVOID_CATEGORIES.test(c));

  const deepest = validHierarchy[validHierarchy.length - 1] ?? "";
  return capitalize(deepest);
};

// Tipo de envio do pedido por item. Exemplos: “retirada em loja” e “receba em casa”. Caso tenha disponível a informação da loja de retirada ou o modelo de entrega em casa (normal, rápida, expresso…) colocar com “:” na frente como detalhamento, exemplo “retirada em loja: FARM SHOPPING LEBLON” ou “Receba em casa: expresso”.
export function getItemShippingTier(orderForm: OrderForm | undefined, item: OrderFormItem) {
  const info = orderForm?.shippingData?.logisticsInfo?.find(
    (li: LogisticsInfo) => li.itemId === item.id
  );

  const selectedSla = info?.slas?.find((sla) => sla.id === info.selectedSla);
  return selectedSla?.pickupStoreInfo?.friendlyName
    ? `retirada em loja: ${selectedSla.pickupStoreInfo.friendlyName}`
    : selectedSla?.name
      ? `Receba em casa: ${selectedSla.name}`
      : null;
}

export const getPaymentType = (context: Record<string, any>): string | null => { 
  if (context.payment_type) return context.payment_type;
  if (!context.orderForm) return null;

  const giftCards = context.orderForm.paymentData?.giftCards || [];
  if (giftCards.some((g: { inUse: boolean }) => g?.inUse)) return 'vale';

  const payments = context.orderForm.paymentData?.payments || [];
  const systems = context.orderForm.paymentData?.paymentSystems || [];
  if (!payments.length || !systems.length) return null;

  const selectedPayment = payments.find((p: { paymentSystem: string }) => p?.paymentSystem) || payments[0];
  const id = String(selectedPayment?.paymentSystem || '').trim();
  if (!id) return null;

  const system = systems.find((s: { id: string }) => String(s.id) === id);
  const name = system?.name?.toLowerCase() || '';
  const match = paymentTypeMap.find(([key]) => name.includes(key));

  return match ? match[1] : null;
}
